import { render, staticRenderFns } from "./ProjectTissueCropFormGroups.vue?vue&type=template&id=1f81aa0c"
import script from "./ProjectTissueCropFormGroups.vue?vue&type=script&lang=js"
export * from "./ProjectTissueCropFormGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports